<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="产品资料预览"
      :showFooter="false"
      :innerHeight="420"
      width="960px"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      v-el-drag-dialog
    >
      <!-- // 业务 -->
      <el-row :gutter="15" style="width: 100%;">
        <!-- 预览 -->
        <el-col :span="18">
          <div
            style="width: 100%; background: #eee;height: 48px;line-height: 48px;text-align: center;font-weight: bold;"
            v-if="adapterMattress">{{adapterMattress}}
          </div>
          <el-table
            :data="finalTableData"
            border
            :height="dialogHieght"
            :cell-class-name="cellClassNameMethod"
            v-if="tableHeadList.length"
            :show-header="false"
            :span-method="spanRow"
            ref="elTable"
          >
            <el-table-column :label="item.label" :prop="item.prop" v-for="item in tableHeadList" :key="item.prop" :width="item.prop === 'name' || item.prop === 'spanName' ? '80px' : ''">
              <template slot-scope="scope">
                <span v-if="scope.row.name == '图片' && scope.column.property !== 'name' && scope.column.property !== 'spanName'">
                  <el-image :src="scope.row[scope.column.property]" style="width: 100px height: 100px"
                            fit="cover"></el-image>
                </span>
                <span v-else>
                  <template v-if="scope.column.property == 'name' && scope.column.property !== 'spanName'">{{scope.row['name']}}</template>
                  <template v-else>
                    <span v-if="!editStatus" v-html="brightenKeyword(scope.row[scope.column.property], keyword, indexVal)"></span>
                    <el-input
                      autosize
                      type="textarea"
                      v-model="scope.row[scope.column.property]"
                      size="mini"
                      @focus="focus(scope)"
                      @input="input"
                      @blur="onBlur(scope)" 
                      v-else/>
                  </template>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <!-- 操作记录 -->
        <el-col :span="6">
          <div>
            <el-button type="primary" size="small" @click="edit"  v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$editProInformation`">
              {{editStatus ? '完成' : '编辑'}}
            </el-button>
            <el-button type="primary" size="small"  v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$replaceProInformation`" plain @click="onReplace">替换</el-button>
          </div>
          <div class="time-line-wrapper">
            <div class="title">修改记录</div>
            <el-timeline :reverse="reverse" :style="{'height': timelineHeight}">
              <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="activity.timestamp"
                :color="activity.dataId === activeTime.dataId ? '#F0F3BD' : '#00A896'"
                @click.native="timeLineClick(activity)"
                :class="{active: activity.dataId === activeTime.dataId}">
                <!-- {{activity.content}} -->
                <div class="timeline-desc">{{activity.modifyFieldDesc}}</div>
                <div class="timeline-modify" v-if="activity.modifyBefore!='空'">{{activity.modifyBefore}}</div>
                <div class="timeline-split">{{activity.text}}</div>
                <div class="timeline-modify">{{activity.modifyAfter}}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>

      <replace
        ref="replace"
        :visible.sync="replaceVisible"
        :finalTableData="finalTableData"
        :fileId="fileId"
        :fileTypeCode="fileTypeCode"
        v-if="replaceVisible"
        @matched="handleMatched"
        @complete="handleReplaceComplete"
      ></replace>
    </q-dialog>
  </div>
</template>

<script>
  import elDragDialog from "@/directive/el-drag-dialog/index.js"; //01先引入这个指令

  import elTableHighlight from "@/directive/el-table-highlight/index.js"; 

  import replace from './replace'
import colorsMixin from '../../../goodsAnalysis/colors.mixin';

  export default {
    model: {
      prop: 'visible',
      event: 'input'
    },
    props: ['visible', 'spuId', 'fileId'],
    directives: {elDragDialog, elTableHighlight},
    components: {replace},
    data() {
      return {
        originData: null,
        hasChange: false,
        tableData: [],
        reverse: false,
        activities: [],
        editStatus: false,
        activeTime: {},
        replaceVisible: false,
        matchedRow: {},
        fileTypeCode: '',
        adapterMattress: null,
        keyword: '',
        timelineHeight: 0,
        indexVal: "",
        colorIndex: 0,
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        },
      },
      dialogHieght() { //拉伸高度计算
         let height = parseInt(this.$store.state.preSalePlan.dialogHieght)
         if(height == 0){
           height = 390
           this.timelineHeight = '365px'
         }else{
           height -= 130
           this.timelineHeight = (height - 25) + 'px'
         }
         return height
         
      },
      // 格式化表格数据，改为竖排
      formatTableData() {
        let props;
        if (this.fileTypeCode == '1') {
          // 板式
          props = [
            {prop:'',label:''},
            // {prop: 'describeContent', label: '描述内容'},
            {prop: 'model', label: '型号'},
            {prop: 'name', label: '名称'},
            {prop: 'image', label: '图片'},
            {prop: 'channelAdvice', label: '渠道建议'},
            {prop: 'style', label: '风格定位'},
            {prop: 'color', label: '产品颜色'},
            {prop: 'material', label: '基础材质'},
            {prop: 'completeBedBody', label: '配套床体'},
            {prop: 'adapterMattress', label: '适配床垫'},
            {prop: 'antiScope', label: '抗菌范围'},
            {prop: 'storage', label: '储物'},
            {prop: 'craft', label: '工艺'},
            {prop: 'function', label: '功能'},
            {prop: 'mainTrait', label: '主要特点'},
            {prop: 'wholeTrait', label: '整体特征'},
            {prop: 'productTrait', label: '产品特征'},
          ]
        } else if (this.fileTypeCode == '2') {
          // 软床沙发
          props = [
            {prop:'',label:''},
            {prop: 'model', label: '型号名称', spanName: '型号规格'},
            {prop: 'style', label: '风格定位', spanName: '型号规格'},
            {prop: 'channel', label: '渠道', spanName: '型号规格'},
            {prop: 'productCategory', label: '产品类别', spanName: '型号规格'},
            {prop: 'materialAndColor', label: '产品材质&颜色', spanName: '型号规格'},
            {prop: 'specification', label: '规格', spanName: '型号规格'},

            {prop: 'function', label: '功能', spanName: '详细配置'},
            {prop: 'removableWashableParts', label: '可拆洗部位', spanName: '详细配置'},
            {prop: 'fillerProportion', label: '填充物及比例', spanName: '详细配置'},
            {prop: 'baseTechnologyAndSofaLeg', label: '底座工艺&沙发脚', spanName: '详细配置'},
            {prop: 'mattressPlacement', label: '床垫置放方式', spanName: '详细配置'},
            {prop: 'mattressThickness', label: '最高可配床垫厚度', spanName: '详细配置'},
            {prop: 'bedFrameAndFoot', label: '排骨架&床脚', spanName: '详细配置'},

            {prop: 'image', label: '图片', spanName: '详细卖点'},
            {prop: 'basicInformation', label: '基础信息', spanName: '详细卖点'},
            {prop: 'coreBenefits', label: '核心利益', spanName: '详细卖点'},
            {prop: 'productSize', label: '产品尺寸', spanName: '详细卖点'},
          ]
        } else if (this.fileTypeCode == '3') {
          // 床垫
          props = [
            {prop:'',label:''},
            {prop: 'model', label: '型号'},
            {prop: 'image', label: '图片'},
            {prop: 'specification', label: '规格'},
            {prop: 'productMaterial', label: '主材'},
            {prop: 'coreConfig', label: '核心配置'},
            {prop: 'thickness', label: '厚度'},
            {prop: 'fabric', label: '详细信息-面料'},
            {prop: 'latex', label: '详细信息-乳胶'},
            {prop: 'springOne', label: '详细信息-弹簧1'},
            {prop: 'springTwo', label: '详细信息-弹簧2'},
            {prop: 'isTwoSidedUse', label: '是否双面可用'},
            {prop: 'upgradeModelSummary', label: '升级款型总结'},
            {prop: 'hardnessTag', label: '软硬度标注（区分正反面，按照下面五个维度标注）'},
            {prop: 'mattressLayer', label: '床垫分层（从正面上到下每一层材质，不用区分正反面）'},
            {prop: 'benefit', label: '利益点'}
          ]
        } else {
          props = [];
        }
        let newData = [];
        props.forEach(item => {
          // 添加第一,二列（左侧表头）
          let tempObj;
          if(this.fileTypeCode == '2') {
              tempObj = {
                spanName: item.spanName,
                name: item.label,
              }
          }else{
            tempObj = {
              name: item.label
            }
          }
          this.tableData.forEach((row, index) => {
            tempObj[`prop${index}`] = row[item.prop];
            tempObj[`field`] = item.prop;
            tempObj[`prop${index}_dataId`] = row.dataId;
          })
          newData.push(tempObj)
        });
        return newData;
      },
      tableHeadList() {
        let tempArr = [];
        if (!this.formatTableData.length) return [];
        Object.keys(this.formatTableData[0]).forEach((key, index) => {
          if (key !== 'field' && !key.includes('_dataId')) {
            tempArr.push({
              label: this.formatTableData[0][key],
              prop: key
            })
          }
        });
        return tempArr
      },
      finalTableData() {
        return JSON.parse(JSON.stringify(this.formatTableData.slice(1)))
      },
      originFinalTableData() {
        return JSON.parse(JSON.stringify(this.formatTableData.slice(1)))
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      focus(data, $event) {
        this.originData = data.row[data.column.property]
      },
      input(e) {
        this.hasChange = e !== this.originData
      },
      updateVal() {
        this.dialogVisible = false;
        if (this.isNeedRefresh) {
          this.$emit('success');
        }
        this.$emit('close');
      },
      confirm() {
        this.updateVal();
      },
      /**
       * 初始化
       */
      // 获取预览数据
      init() {
        let data = {
          fileId: this.fileId,
          spuId: this.spuId
        };
        return this.$q.newProduct.queryExcuseData({params: data})
          .then(res => {
            this.tableData = res.data.data.map(v => {
              return {
                ...v,
                image:  res.data.image ? res.data.image.path : ''
              }
            });
            this.fileTypeCode = res.data.fileTypeCode;
            /*        if(res.data.data.length && res.data.data[0].adapterMattress){
                      this.adapterMattress = res.data.data[0].adapterMattress
                    }else{
                      this.adapterMattress = null
                    }*/
            this.adapterMattress = res.data.fileTypeName
          })
          .then(_ => {
            this.recordList();
          })
      },
      /**
       * 编辑功能
       */
      edit() {
        this.editStatus = !this.editStatus;
        console.log(this.dialogHieght);
      },
      onBlur(scope) {
        if (!this.hasChange) return
        this.hasChange = false
        this.originData = null
        // 当前单元格所在列的prop
        let fileIdName = scope.column.property;
        // 当前单元格的值所对应原始数据里的dataId
        let dataId = scope.row[`${fileIdName}_dataId`]
        let data = {
          fileId: this.fileId,
          baseDataId: dataId,
          modifyAfter: scope.row[fileIdName],
          modifyBefore: this.originFinalTableData[scope.$index][fileIdName],
          modifyField: scope.row.field,
          modifyFieldDesc: scope.row.name,
          businessType: this.fileTypeCode
        }
        this.$q.newProduct.editInformation({data})
          .then(res => {
            if (res.code == 200) {
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.message)
            }
          })
          // 初始化修改记录
          .then(_ => {
            this.recordList();
            this.init();
          })
      },
      /**
       * 查找替换功能
       */
      onReplace() {
        this.replaceVisible = true;
      },
      // 查找到关键字数据的回调函数
      handleMatched(data,val,colorIndex) {
          this.matchedRow = data;
          console.log(data);
          this.scrollTable(data);
          this.keyword = this.$refs['replace'].formData.keyword;
          this.colorIndex = colorIndex || 1;
          this.indexVal = val
      },
      cellClassNameMethod({row, column, rowIndex, columnIndex}) {
        
        let matchedData = []
        matchedData = [this.matchedRow]
        let status = matchedData.find(v => {
          return v.row === rowIndex && v.prop === column.property
        })
        if (status) {
          return 'active'
        }
      },
      // 替换成功回调
      async handleReplaceComplete() {
        await this.init();
        this.$refs['replace'].search();
      },
      /**
       * 修改记录
       */
      recordList() {
        this.$q.newProduct.getChangeRecord({
          params: {
            businessType: this.fileTypeCode,
            fileId: this.fileId
          }
        })
          .then(res => {
            if (res.code == 200) {
              this.activities = res.data.map(v => {
                var text = ''
                if(v.modifyBefore == '空' && v.modifyAfter) {
                  text = '新增'
                }else if(v.modifyBefore && !v.modifyAfter) {
                  text = '删除'
                }else if(v.modifyBefore && v.modifyAfter) {
                  text = '修改为'
                }
                // console.log(v);
                return {
                  ...v,
                  timestamp: v.createdDate,
                  text: text,
                  content: `${v.modifyFieldDesc}`
                  // content: `${v.modifyFieldDesc}-${v.modifyBefore}${v.modifyAfter ? v.modifyAfter : '空'}`
                }
              });
            }
          })
      },
      timeLineClick(item) {
        console.log(item)
        this.activeTime = item;

        // 高亮修改行
        let baseDataId = item.baseDataId;
        let modifyFieldDesc = item.modifyFieldDesc;

        // 定位行数
        let index = this.finalTableData.findIndex(v => v.name === modifyFieldDesc);
        // 定位列名
        let fieldName;
        Object.keys(this.finalTableData[index]).forEach(key => {
          let tag = this.finalTableData[index];
          if (key.includes('_dataId') && tag[key] == baseDataId) {
            fieldName = key.split('_')[0]
          }
        })
        

        console.log(index, fieldName);
        this.matchedRow = {
          row: index,
          prop: fieldName
        }
        this.scrollTable(this.matchedRow);
      },
      // table滚动条滚动
      scrollTable({prop, row}) {
        let $scrollEl = this.$refs['elTable'].$el.querySelector('.el-table__body-wrapper');
        let $content = this.$refs['elTable'].$el.querySelector('.el-table__body-wrapper tbody');
        let $trList = $content.querySelectorAll('tr');
        // console.log($trList);

        let offsetHeight = $trList[row].offsetTop;
        // console.log(offsetHeight);
        $scrollEl.scrollTop = offsetHeight - 30;
      },
      /**
       * 高亮
       */
      // 或者用正则表达式
      brightenKeyword(val, keyword, indexVal) {
        console.log(this.colorIndex);
        val = val + '';
        const str = keyword.replace(/([*.?+$^(){}|\\/])/g, '\\$1')
        const reg = new RegExp(str, "g");
        if(val.indexOf(keyword) !== -1 && keyword !== '' &&  val.split(keyword).length - 1>1 && val == indexVal) {
          let index = 0
          return val.replace(reg, (a, b, c) => {
              if(c == indexVal) index++; 
              return `<font color="${this.colorIndex == index ? '#FF3C38' : '#70c1b3'}">${keyword}</font>`;
          });
        }
        if (val.indexOf(keyword) !== -1 && keyword !== '') { 
          return val.replace(reg, '<font color="#FF3C38">' + keyword + '</font>')
        } else {
          return val
        }
        
      },
      /**
       * 单元格合并
       */
      spanRow({ row, column, rowIndex, columnIndex }) {
        // 软床沙发
        if(this.fileTypeCode == '2') {
          if(columnIndex === 0) {
            if(rowIndex === 0) {
              return {
                rowspan: 6,
                colspan: 1
              };
            } else if(rowIndex === 6) {
              return {
                rowspan: 7,
                colspan: 1
              };
            } else if(rowIndex === 13) {
              return {
                rowspan: 4,
                colspan: 1
              };
            } else {
              return {
                rowspan: 0,
                colspan: 1
              };
            }
          }
        }
      }
    },
    beforeDestroy() {
      this.$store.commit('preSalePlan/delHieght')
    }
  }
</script>

<style lang="stylus" scoped>
  .time-line-wrapper
    margin-top 10px

    .title
      margin-bottom 10px
      color #999999

  >>> .el-timeline
    padding-left 5px
    height 365px
    overflow auto
    padding-top 10px

    .el-timeline-item
      position relative
      z-index 10
      cursor pointer

      &::after
        position absolute
        content ""
        z-index -1
        left 0
        right -10px
        transition all linear .3s

      &.active
        &::after
          left 15px
          bottom 15px
          right 0px
          top -10px
          background #f4f4f4

  >>> .el-table__row
    td.active
      background #F1FAEE
      color #70C1B3
      .cell
        background #F1FAEE
        color #70C1B3
    /* 第一列为表头，不参与全局关键字高亮检索 */
    td:first-child
      .cell *
        background transparent !important

  >>> .el-table .cell
    white-space pre-line
  
  >>> .el-table
     transition all 0s
  >>> .red 
    color red
  
  >>> .yellow
    color #606266

  .timeline
    &-desc
      font-size 14px
      color #555
      font-weight bold
      line-height 1.4
      padding-right 10px
    &-modify
      font-size 12px
      color #777
      line-height 1.4
      text-align justify
      padding-right 10px
    &-split
      font-size 14px
      color rgb(0, 168, 150)
      line-height 1.4
      padding-right 10px
</style>
